import React from "react";
import { Modal } from "react-bootstrap";

const TermsConditionsModal = ({ open, close }) => {
  return (
    <Modal
      show={open}
      onHide={close}
      dialogClassName="terms-modal am-reading"
      backdrop="static"
      keyboard={false}
      centered
      scrollable
      aria-labelledby="landing-terms-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="landing-terms-title">Terms and Conditions</Modal.Title>
      </Modal.Header>
      <p className="am-band">Please read before you chat with Anna</p>
      <Modal.Body>
        <section className="am-section">
          <p>
            <b>In using Anna, you agree to these terms and conditions:</b>
          </p>
          <ol className="am-steps">
            <li>
              All responses and correspondences with Anna will be recorded.
            </li>
            <li>
              Information such as your name, age, sex, strand or track (if
              any), your answers to the assessments, and related correspondence
              will be for the exclusive use of ANNA and the school to
              continuously improve Anna.
            </li>
            <li>
              The data collected will be used for as long as it is needed for
              further analysis or investigation.
            </li>
            <li>
              You are free to exit the conversation with Anna if you feel the
              need to do so.
            </li>
          </ol>
        </section>

        <section className="am-section">
          <h3 className="am-section-title">User guidelines</h3>
          {/* How ANNA really behaves (2026-10-20): no idle timer in the tests; unfinished tests keep 7 days */}
          <p>{"Anna chats in English, so it's best to type your messages in English."}</p>
          <p>{"Take your time. There's no time limit on any question. Your answers are saved after each one, so you can stop and come back later to pick up where you left off."}</p>
          <p>{"Come back within 7 days of your last answer and before your guidance office's deadline for that test. After 7 days away, an unfinished test starts again from the first question."}</p>
          <p>{"If you're asked to sign in again after a break, your saved answers will still be there."}</p>
          <p>{"If you leave a typed chat with Anna for a while, she may lose track of it. Say \"Hi\" to start again."}</p>
          <p>
            If any problems occur during the conversation process, or you have
            any suggestions or comments you would like to share, please leave a
            feedback. Your insights and suggestions would help improve ANNA.
          </p>
        </section>

        <section className="am-section">
          <h3 className="am-section-title">Confidentiality</h3>
          <p>
            The information that Anna will be obtaining throughout the
            conversation will remain confidential to protect your rights or
            welfare.
          </p>
          <p>
            RA 10173 or the Data Privacy Act protects individuals from
            unauthorized processing of personal information. To ensure that your
            information is protected, ANNA follows this law to keep your
            information safe and confidential.
          </p>
        </section>

        <section className="am-section">
          <h3 className="am-section-title">Definitions</h3>
          <p>
            Throughout the conversation, Anna will be responding to possible
            jargons. To ensure that you understand Anna, the definition of words
            will be provided:
          </p>
          <p>
            <b>Degree Program</b> - A class that a college or university offers
            to students. (Bachelor of Science in Information Technology, etc..)
          </p>
          <p>
            <b>RIASEC</b> - A personality test that asks about your interest,
            skills, ability, and aspirations which will help you decide on what
            career to pursue based on these attributes.
          </p>
          <p>
            <b>SDQ</b> - The Strengths and Difficulties Questionnaire. It asks
            about your behavior, your feelings and how you get along with others.
          </p>
          <p>
            <b>DASS-42</b> - The Depression, Anxiety and Stress Scale. It asks
            how you have been feeling over the past week.
          </p>
          <p>
            <b>Ryff scale</b> - Ryff's Scales of Psychological Well-being. It
            asks about six areas of well-being, such as purpose in life and
            personal growth.
          </p>
          <p>
            <b>Strand or track</b> - The senior high school track a student is
            in, such as STEM or ABM. It only applies to senior high students.
          </p>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="am-btn is-primary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsConditionsModal;
